import styled from "styled-components";

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  
  button {
    color: #2125FF !important;
    /* Usa o mesmo azul do ExternalUserLink */
    font-weight: 700;
    
    /* Remove underline, caso algum botão seja link */
    text-decoration: none;
  }
`;